import moment from 'moment';
import * as aq_helper from '@/util/aq_helper';
import fetch from '@/util/fetch';
import statusCode from '@/assets/constant/statusCode';

/*
回傳變數命名格式
aqt: arquero table
rds: JSON物件陣列

overall: 不分維度全彙總
site
game_brand
game_kind
...

basic
gaming
trans
promo
...

lifetime: 過往迄今加總
total: 指定時間範圍加總
daily
hourly
...

ex: aqt_site_basic_daily

*/

export function get_previous_period_date_range(req_params){
  const mdate_start = moment(req_params.p_rpt_date_start).utc();
  const mdate_end = moment(req_params.p_rpt_date_end).utc();
  const diff_days = mdate_start.diff(mdate_end, 'day');
  return {
    rpt_days: Math.abs(diff_days) + 1,
    prev_date_start: mdate_start.add(diff_days, 'day').format('YYYY-MM-DD'),
    prev_date_end: mdate_end.add(diff_days, 'day').format('YYYY-MM-DD'),
  };
}

export async function post_concurrently(req_list) {
  const promise_list = req_list.map(em_i => fetch.cars_post('/cars/ocms/reporting/' + em_i[1], em_i[2]));
  const response_list = await Promise.all(promise_list);

  const r_dataset = {};
  response_list.forEach((response, idx) => {
    const key = req_list[idx][0];
    // 把 STATUS_OK 和 STATUS_NO_DATA 都視為成功
    if (response.status === statusCode.STATUS_OK || response.status === statusCode.STATUS_NO_DATA) {
      r_dataset[key] = g_aq.from(response.result || []);
    }
  });

  return r_dataset;
}

export async function post_sequential(req_list) {
  let r_dataset = {};
  for(const em_i of req_list){
    const response = await fetch.cars_post('/cars/ocms/reporting/' + em_i[1], em_i[2]);
    // 把 STATUS_OK 和 STATUS_NO_DATA 都視為成功
    if(response.status === statusCode.STATUS_OK || response.status === statusCode.STATUS_NO_DATA) {
      r_dataset[em_i[0]] = g_aq.from(response.result || []);
    }
  }
  return r_dataset;
}

export async function post_login(req_params_0) {

  const r_dataset = await post_concurrently([
    ['aqt_game_kind_profile', 'get_game_kind_brand_profile', {
      ...req_params_0,
      p_group_by_column_list: ['game_kind_code'],
    }],
    ['aqt_game_brand_profile', 'get_game_kind_brand_profile', {
      ...req_params_0,
      p_group_by_column_list: ['game_brand_code'],
    }],
  ]);

  if(0 == Object.keys(r_dataset).length)
    return {rds_status: statusCode.STATUS_FAIL};

  let {
    aqt_game_kind_profile,
    aqt_game_brand_profile,
  } = r_dataset;

  const rds_game_kind_profile = aqt_game_kind_profile
  .select('game_kind_code', 'game_kind_name')
  .orderby(0)
  .objects()

  const rds_game_brand_profile = aqt_game_brand_profile
  .select('game_brand_code')
  .orderby(0)
  .objects()

  return {
    rds_status: statusCode.STATUS_OK,
    rds_game_kind_profile,
    rds_game_brand_profile,
  };
}
